import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  health: {
    buildVersion: ""
  },
  profile: null,
  isFetching: false,
  isLoadingMore: false,
  error: null
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('systemStatus')(configurations),
  [LOCATION_CHANGE]: (state, action) => {
    return {
      ...initialState,
      profile: state.profile
    };
  }
}, initialState);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/system-status/reducers.js